import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex cursor-pointer"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 1,
  class: "no-image-placeholder rounded",
  style: {"width":"100px","height":"100px"}
}
const _hoisted_4 = { class: "ms-7" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "text-blue ms-2 font-bold" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mt-2 font-bold" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "ml-2"
}

import { computed } from 'vue'
import { format } from 'date-fns'
import Subscription, { StripeUpcomingInvoice } from '../../../api/v2/models/subscription'


export default /*@__PURE__*/_defineComponent({
  __name: 'Subscription',
  props: {
    subscription: {},
    stripeUpcomingInvoice: { default: null }
  },
  setup(__props: any) {

const props = __props

const nextPaymentDate = computed(() => {
  if (props.stripeUpcomingInvoice && props.stripeUpcomingInvoice.periodEnd) {
    return dateFormat(props.stripeUpcomingInvoice.periodEnd)
  }
  return null
})

const installmentPerPeriod = computed((): number => {
  const total = props.subscription.purchasePrice || 0
  const count = props.subscription.installmentCountTotal || 1
  return Math.ceil(total / count)
})

const installmentTotalCharged = computed((): number => {
  return props.subscription.purchasePrice || 0
})

const dateFormat = (date: Date) => {
  return format(date, 'YYYY/MM/DD')
}

const hasImage = computed((): boolean => {
  return !!props.subscription.premiumServiceUrl
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (__props.subscription)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (hasImage.value)
            ? (_openBlock(), _createBlock(_component_v_img, {
                key: 0,
                "min-height": "100",
                "min-width": "100",
                "max-height": "100",
                "max-width": "100",
                src: __props.subscription.premiumServiceUrl,
                class: "rounded"
              }, null, 8 /* PROPS */, ["src"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_icon, {
                  size: "large",
                  color: "grey"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-image-off", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (__props.subscription.isTrailing)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  class: "text-white",
                  color: "green",
                  size: "small",
                  label: ""
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" 体験中 ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (__props.subscription.isStoped)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 1,
                  class: "text-white",
                  color: "red",
                  size: "small",
                  label: ""
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" キャンセル済み ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (__props.subscription.isDone)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 2,
                  class: "text-white",
                  color: "green",
                  size: "small",
                  label: ""
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" アクティブ ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (__props.subscription.isPending)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 3,
                  class: "text-white",
                  color: "red",
                  size: "small",
                  label: ""
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" 未払い ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.subscription.premiumServiceName), 1 /* TEXT */)
          ]),
          _createElementVNode("div", {
            class: "mt-2 text-gray",
            innerHTML: __props.subscription.premiumServiceDescription
          }, null, 8 /* PROPS */, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _createCommentVNode(" Monthly subscription "),
            (__props.subscription.isEachMonth)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" 定期購入 " + _toDisplayString((__props.subscription.price || __props.subscription.premiumServicePrice || 0).toLocaleString()) + "円/月 ", 1 /* TEXT */),
                  (nextPaymentDate.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "次回 " + _toDisplayString(nextPaymentDate.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : (__props.subscription.edbaseInstallment)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Edbase installment (life_time with subscription schedule) "),
                    _cache[5] || (_cache[5] = _createTextVNode(" 分割払い ", -1 /* CACHED */)),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "price-spacer" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(__props.subscription.pricePlan) + " ", 1 /* TEXT */),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "price-spacer" }, null, -1 /* CACHED */)),
                    _createTextVNode(" 月額 ¥" + _toDisplayString(installmentPerPeriod.value.toLocaleString()) + " × 全 " + _toDisplayString(__props.subscription.installmentCountTotal) + " 回 総額 ¥" + _toDisplayString(installmentTotalCharged.value.toLocaleString()) + "（税込） ", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (__props.subscription.isLifeTime)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createCommentVNode(" Life time purchase "),
                      _cache[8] || (_cache[8] = _createTextVNode(" 一括購入 ", -1 /* CACHED */)),
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "price-spacer" }, null, -1 /* CACHED */)),
                      _createTextVNode(" " + _toDisplayString(__props.subscription.pricePlan) + " ", 1 /* TEXT */),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "price-spacer" }, null, -1 /* CACHED */)),
                      _createTextVNode(" " + _toDisplayString((__props.subscription.purchasePrice || 0).toLocaleString()) + "円 ", 1 /* TEXT */),
                      (__props.subscription.hasCoupon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _createVNode(_component_v_chip, {
                              color: "green",
                              small: "",
                              label: "",
                              class: "text-white"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" クーポン: " + _toDisplayString(__props.subscription.couponCode), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})